exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-lazy,.vux-x-img{-webkit-transition:opacity .5s ease-in-out;transition:opacity .5s ease-in-out;max-width:100%}.b-lazy{opacity:0}.b-lazy.b-loaded{opacity:1}", ""]);

// exports
